import MainLayout from "../../../layouts/main/main_layout";
import HospitalLayout from "../../../layouts/hospitals/hospital_layout";
import {
  createHospitalSpeciality,
  deleteHospitalSpeciality,
  getHospitalSpecialities,
  updateHospitalSpeciality,
} from "../../../services/hospitals/hospitals";
import HospitalMasterList from "../components/hospital_master_list/hospital_master_list";

export default function HospitalSpecialities() {
  return (
    <MainLayout>
      <HospitalLayout>
        <HospitalMasterList
          itemLabel="Speciality"
          itemLabelPlural="Specialities"
          queryKey="hospital-specialities"
          getItems={getHospitalSpecialities}
          createItem={createHospitalSpeciality}
          updateItem={updateHospitalSpeciality}
          deleteItem={deleteHospitalSpeciality}
        />
      </HospitalLayout>
    </MainLayout>
  );
}
